<template>
  <div>
    <span>正在跳转...</span>
  </div>
</template>
<script>
import {
  GetOpenId,
  GetAllCardByOpenID,
  SetItem,
  RemoveItem,
  GetAuthorizeUrl,
  GetItem,
  GetWXUserInfo,
  GetPayData
} from "@/services/getData.js";

import weui from "weui.js";
export default {
  name: "navigation",
  data() {
    return {
      pageType: this.$route.query.pageType,
      QRCode: this.$route.query.QRCode
    };
  },
  created: function() {
    this.getOpenId();
  },
  methods: {
    gotoPage() {
      //if (this.QRCode) {
      //  //跳转到建档页面
      //  if (GetItem("hosid") == null) {
      //    this.$router.push({
      //      path: "/home/choose",
      //      query: { source: 0 , qrCode: true }
      //    });
      //  } else {
      //    this.$router.push({
      //      path: "/card/addcard",
      //      query: { active: true, qrCode: true }
      //    });
      //  }
      //}
      //else {

      //}
      switch (this.pageType) {
        case "1":
          //科室简介
          this.$router.push({ path: "/home/choose", query: { source: 2 } });
          break;
        case "2":
          //院区简介
          this.$router.push({ path: "/home/choose", query: { source: 1 } });
          break;
        case "3":
          //预约挂号
          this.registerfun();
          break;
        case "4":
          //候诊查询
          this.waiting();
          break;
        case "5":
          //门诊缴费
          this.payfun();
          break;
        case "6":
          //报告查询
          this.reportfun();
          break;
        case "7":
          //建档绑卡
          this.addcard(true);
          break;
        case "8":
          //挂号记录
          this.recordFun();
          break;
        case "9":
          //就诊记录
          this.medicalRecord();
          break;
        case "10":
          //缴费记录
          this.payRecord();
          break;
      }
    },
    swith() {
      //跳转到切换就诊人页
      this.$router.push({ path: "/card/switchcard" });
    },
    addcard(type) {
      var _that = this;
      if (GetItem("patid") == null && type != true) {
        weui.dialog({
          title: "提示",
          content: "请先建立档案",
          buttons: [
            {
              label: "确定",
              type: "primary",
              onClick: function() {
                //跳转到添加就诊卡页
                if (GetItem("hosid") == null) {
                  _that.$router.push({
                    path: "/home/choose",
                    query: { source: 0 }
                  });
                } else {
                  _that.$router.push({
                    name: "AddCard",
                    params: { active: true }
                  });
                }
              }
            }
          ]
        });
      } else {
        //跳转到添加就诊卡页
        if (GetItem("hosid") == null) {
          this.$router.push({ path: "/home/choose", query: { source: 0 } });
        } else {
          this.$router.push({ name: "AddCard", params: { active: true } });
        }
      }
    },
    registerfun() {
      //跳转到预约挂号(选择院区)
      this.$router.push({ path: "/home/choose", source: -1 });
    },
    payfun() {
      //跳转到门诊缴费
      if (GetItem("patid") == null) {
        this.addcard();
      } else {
        this.$router.push({
          path: "/pay/outpatienthome",
          params: { userId: 123 }
        });
      }
    },
    waiting() {
      //跳转到候诊无卡添加卡
      //  this.$router.push({ path: "/waiting/nocard", params: {} });
      //跳转到候诊信息页
      //跳转到门诊缴费
      if (GetItem("patid") == null) {
        this.addcard();
      } else {
        this.$router.push({ path: "/waiting/waitinformation", params: {} });
      }
    },
    reportfun() {
      //跳转到报告查询
      if (GetItem("patid") == null) {
        this.addcard();
      } else {
        this.$router.push({ path: "/report/query", params: {} });
      }
    },
    satisFun() {
      //跳转到满意度查询
      if (GetItem("patid") == null) {
        this.addcard();
      } else {
        this.$router.push({ path: "/satisfaction/query", params: {} });
      }
    },
    centerFun() {
      //跳转到个人中心
      if (GetItem("patid") == null) {
        this.addcard();
      } else {
        this.$router.push({ path: "/person/center", params: {} });
      }
    },
    treatmentFun() {
      //跳转到治疗计划
      if (GetItem("patid") == null) {
        this.addcard();
      } else {
        this.$router.push({ path: "/treatment/treatmentplan", params: {} });
      }
    },
    recordFun() {
      //跳转到挂号记录
      if (GetItem("patid") == null) {
        this.addcard();
      } else {
        this.$router.push({ path: "/person/record", params: {} });
      }
    },
    medicalRecord() {
      //跳转到就诊记录
      if (GetItem("patid") == null) {
        this.addcard();
      } else {
        this.$router.push({ path: "/person/medic", params: {} });
      }
    },
    payRecord() {
      //跳转到缴费记录
      if (GetItem("patid") == null) {
        this.addcard();
      } else {
        this.$router.push({ path: "/person/paymentrecord", params: {} });
      }
    },
    query() {
      //跳转到报告查询
      if (GetItem("patid") == null) {
        this.addcard();
      } else {
        this.$router.push({ path: "/report/query", params: {} });
      }
    },
    getAllCardByOpenID() {
      var loading = weui.loading("loading", {
        className: "custom-classname",
        content: "加载中"
      });
      var _that = this;
      GetAllCardByOpenID().then(response => {
        loading.hide();
        if (response.data) {
          if (response.data.length > 0) {
            response.data.forEach(function(item) {
              if (item.Default) {
                _that.$store.commit("setUserInfo", item);
                SetItem("patid", item.PatID);
              }
            });
          }
          this.gotoPage();
        }
      });
    },
    getOpenId() {
      var code = this.getUrlCode().code;
      if (code) {
        if (GetItem("openid") == null) {
          //获取到code以查找openid
          GetOpenId(code).then(response => {
            SetItem("openid", response.data);
            this.getAllCardByOpenID();
          });
        } else {
          this.getAllCardByOpenID();
        }
      } else {
        RemoveItem("openid");
        RemoveItem("patid");
        RemoveItem("APPSTATE");
        RemoveItem("hosid");
        GetAuthorizeUrl("/#/navigation?pageType=" + this.pageType)
          .then(response => {
            window.location.replace(response.data);
          })
          .catch(function(err) {});
      }
    },
    //getOpenId(){
    //  获取到code以查找openid
    //  SetItem("openid", 'ozgr9vh0pxJ0KsZ752xDoOvIYX88');
    //  this.getAllCardByOpenID();
    //},
    getUrlCode() {
      var url = location.search;
      this.winUrl = url;
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
        }
      }
      return theRequest;
    }
  }
};
</script>
<style>
.errorPage {
  height: 100%;
  width: 100%;
  position: relative;
}

.errorPage > div {
  position: absolute;
  color: #999999;
  top: 50%;
  font-size: 0.26rem;
  text-align: center;
  left: 50%;
  margin-left: -1.75rem;
  margin-top: -1.75rem;
}

.errorPage > div > img {
  width: 3.5rem;
  margin-bottom: 0.2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/navigation/navigation.vue